import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "extended-search",
  "use": "extended-search-usage",
  "viewBox": "0 0 17 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 18\" id=\"extended-search\"><path d=\"M9.11 16.47h6.78a.57.57 0 0 0 0-1.15H9.11a2.1 2.1 0 0 0-4.05 0H.57a.57.57 0 0 0 0 1.15h4.49a2.1 2.1 0 0 0 4.05 0m5.75-6.9h1.03a.57.57 0 0 0 0-1.14h-1.03a2.1 2.1 0 0 0-4.06 0H.57a.57.57 0 0 0 0 1.14H10.8a2.1 2.1 0 0 0 4.06 0m-9.2-6.89H15.9a.57.57 0 1 0 0-1.15H5.67a2.1 2.1 0 0 0-4.06 0H.57a.57.57 0 0 0 0 1.15h1.04a2.1 2.1 0 0 0 4.06 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol